import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewContainerDirective} from "./view-container.directive";
import {InViewComponent} from "./in-view.component";

@NgModule({
  declarations: [InViewComponent, ViewContainerDirective],
  imports: [CommonModule],
  exports: [InViewComponent, ViewContainerDirective]
})
export class InViewModule {}
